module.exports = __webpack_public_path__ + "img/angelo.5120b47c.png";